export default __webpack_public_path__ + "static/media/desktop.29767c8e.svg";